import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';

@Injectable()
export class InitRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private commonDataService: CommonDataService,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(): boolean {
        const community = this.authenticationService.community;

        if (this.commonDataService.user.isAdmin || this.commonDataService.user.isSystemAdmin) {
            this.router.navigateByUrl('/' + community + '/community');
        } else {
            this.router.navigateByUrl('/' + community + '/user');
        }

        return true;
    }
}
